import type { Player } from '../types/player';
import type { LeagueConfig } from '../types/league';
import { calculateFormatSpecificRankings } from './formulas/formulaEngine';

/**
 * Enhanced Player Ranking Engine
 * Uses sophisticated formula system for Trade Calculator
 */

export interface EnhancedRankingConfig {
  leagueConfig: LeagueConfig;
  currentRound?: number;
  userTeamNeeds?: string[];
  userRoster?: Player[];
  playerFeedback?: Record<string, any> | null;
}

/**
 * Calculate enhanced player rankings using sophisticated formula engine
 */
export function calculateEnhancedRankings(
  players: Player[],
  config: EnhancedRankingConfig
): Player[] {
  const format = config.leagueConfig.format.type;
  console.log(`🔧 Calculating enhanced rankings for ${format} format using formula engine...`);
  
  // Use the new formula engine for consistent valuation
  const formulaResult = calculateFormatSpecificRankings(players, config.leagueConfig, config.playerFeedback);
  
  return formulaResult.rankedPlayers;
}

// Old multiplier function removed - now using sophisticated formula engine

/**
 * Generate alternative recommendations (simplified)
 */
export function generateAlternativeRecommendations(
  players: Player[],
  _config: EnhancedRankingConfig
): Player[] {
  return players.slice(0, 20);
}
